import React, { useState } from "react";
import { CenterWrapper, Content, ContentHeader, LabelContainer, StyledHeading } from "./styles";
import TextView from "../../TextView";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { Tooltip, IconButton, tooltipClasses, styled } from "@mui/material";
import { useSelector } from "react-redux";
import { radioFields } from "./fields";
import { useUserUpdateProfile } from "../../../services/mutations";
import Button from "../../Button";
import { toast } from 'react-toastify';
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useDispatch } from "react-redux";
import { editUserProfileAction } from "../../../redux/actions";

const CustomTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(() => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: "#D4E2F2E5",
        color: "#123051",
        fontSize: "14px",
        padding: "4px 8px",
        borderRadius: "4px",
    },
    [`& .${tooltipClasses.arrow}`]: {
        color: "#D4E2F2E5",
        marginTop: "8px",
    }
}));

const CustomRadio = styled(Radio)({
    color: "#9B5AF8",
    "&.Mui-checked": {
        color: "#9B5AF8",
    },
    "&:hover": {
        backgroundColor: "rgba(155, 90, 248, 0.1)",
        borderRadius: "50%",
    },
});

export const Visibility = () => {
    const { userProfile } = useSelector((state) => state.userProfile);

    const dispatch = useDispatch();

    const editProfile = useUserUpdateProfile();

    const [loading, setLoading] = useState(false);
    const [value, setValue] = useState(userProfile?.visibility || "PUBLIC");

    const handleChange = (event) => {
        setValue(event.target.value);
    };

    const saveVisibility = () => {
        setLoading(true);
        editProfile.mutateAsync(
            {
                user_profile: {
                    visibility: value
                }
            },
            {
                onSuccess: () => {
                    dispatch(
                        editUserProfileAction({ visibility: value })
                    );
                    toast.success("Visibility updated successfully");
                    setLoading(false);
                },
                onError: (error) => {
                    setLoading(false);
                    toast.error("Visibility update failed");
                }
            }
        );
    }

    return (
        <CenterWrapper>
            <ContentHeader>
                <TextView variant="title">Visibility</TextView>
            </ContentHeader>

            <Content>
                <StyledHeading>Set your account’s visibility here: </StyledHeading>
                <FormControl>
                    <RadioGroup
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={value}
                        onChange={handleChange}
                    >
                        {radioFields.map((field) => (
                            <FormControlLabel 
                                key={field.id} 
                                value={field.value} 
                                control={<CustomRadio />} 
                                label={
                                    <LabelContainer>
                                        {field.label}
                                        {field.showInfo && (
                                            <CustomTooltip title={field.infoMessage} arrow placement="right-start">
                                                <IconButton size="small">
                                                    <InfoOutlinedIcon fontSize="small" color="#BBBBBB" />
                                                </IconButton>
                                            </CustomTooltip>
                                        )}
                                    </LabelContainer>
                                } 
                            />
                        ))}
                    </RadioGroup>
                </FormControl>

                <Button 
                    style={{width: "150px", marginTop: "10px"}} 
                    onClick={saveVisibility}
                    isLoading={loading}
                    disabled={value === userProfile?.visibility}
                >
                    Save
                </Button>
            </Content>
        </CenterWrapper>
    )
}